module.exports = __webpack_public_path__ + "static/media/sybille_mrochen_v2.6dcad567.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/mitarbeiter/sybille_mrochen_v2.jpg
// module id = 438
// module chunks = 0